const REGION_CLASS = {
  'region:invite': 'mc-invite',
  'region:copy': 'mc-copy',
  'region:gallery': 'mc-gallery',
};

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Remove existing rule blocks for selector prefix (best-effort). */
function stripRulesForClass(css, className) {
  const re = new RegExp(
    `[^{}]*\\.${escapeRegExp(className)}\\b[^{]*\\{[^}]*\\}`,
    'gi',
  );
  return (css || '').replace(re, '').trim();
}

export function regionBackgroundFromCss(css, regionKey) {
  const cls = REGION_CLASS[regionKey];
  if (!cls || !css) return { mode: 'none', color: '#1A1A1A', angle: 135, stopA: '#F9BE0B', stopB: '#1A1A1A' };
  const m = css.match(new RegExp(`\\.${cls}\\s*\\{[^}]*background(?:-color)?\\s*:\\s*([^;]+)`, 'i'));
  if (!m) return { mode: 'none', color: '#1A1A1A', angle: 135, stopA: '#F9BE0B', stopB: '#1A1A1A' };
  const val = m[1].trim();
  if (/linear-gradient/i.test(val)) {
    const g = val.match(/linear-gradient\s*\(\s*(\d+)deg\s*,\s*([^,]+)\s*,\s*([^)]+)\)/i);
    if (g) {
      return {
        mode: 'gradient',
        angle: Number(g[1]) || 135,
        stopA: g[2].trim(),
        stopB: g[3].trim(),
        color: '#1A1A1A',
      };
    }
  }
  return { mode: 'solid', color: val.replace(/\s*!important\s*$/i, '').trim(), angle: 135, stopA: '#F9BE0B', stopB: '#1A1A1A' };
}

export function patchRegionBackground(css, regionKey, { mode, color, angle, stopA, stopB }) {
  const cls = REGION_CLASS[regionKey];
  if (!cls) return css || '';
  let next = stripRulesForClass(css || '', cls);
  let bg;
  if (mode === 'gradient') {
    bg = `linear-gradient(${angle || 135}deg, ${stopA || '#F9BE0B'}, ${stopB || '#1A1A1A'})`;
  } else if (mode === 'solid') {
    bg = color || '#1A1A1A';
  } else {
    return next;
  }
  const rule = `.${cls} { background: ${bg}; }`;
  return `${next}\n${rule}`.trim();
}

/** Matches the editor's override rule for one text field, with or without the .mc-invite prefix. */
function editableRuleRegExp(editableKey, flags) {
  const sel = escapeRegExp(`[data-editable="${editableKey}"]`);
  return new RegExp(`(?:\\.mc-invite\\s+)?${sel}\\s*\\{([^}]*)\\}`, flags);
}

/**
 * Per-field text overrides. Prefixed + !important so they beat model CSS such as `.mc-invite .mc-headline`.
 */
export function patchEditableTextStyle(css, editableKey, { color, fontSizePx }) {
  const next = (css || '').replace(editableRuleRegExp(editableKey, 'gi'), '').trim();
  const parts = [];
  if (color) parts.push(`color: ${color} !important`);
  const size = Number(fontSizePx);
  if (fontSizePx !== '' && fontSizePx != null && Number.isFinite(size) && size > 0) {
    parts.push(`font-size: ${size}px !important`);
  }
  if (!parts.length) return next;
  return `${next}\n.mc-invite [data-editable="${editableKey}"] { ${parts.join('; ')}; }`.trim();
}

export function editableTextStyleFromCss(css, editableKey) {
  if (!css || !editableKey) return { color: '', fontSizePx: '' };
  const m = css.match(editableRuleRegExp(editableKey, 'i'));
  if (!m) return { color: '', fontSizePx: '' };
  const block = m[1];
  const colorM = block.match(/(?:^|[;\s])color\s*:\s*([^;]+)/i);
  const sizeM = block.match(/font-size\s*:\s*([\d.]+)px/i);
  return {
    color: colorM ? colorM[1].replace(/\s*!important\s*$/i, '').trim() : '',
    fontSizePx: sizeM ? sizeM[1] : '',
  };
}
